module.exports = __webpack_public_path__ + "static/media/inprocess.5e4a76ef.png";